module.exports = __webpack_public_path__ + "img/logo_bua_wide.08c07036.svg";